<div class="company-assumptions-compare">
  <klt-section
    title="Company level assumptions"
    type="button"
    buttonText="COMPARE"
    (buttonClick)="handleClick()"
  >
  </klt-section>
</div>
